export default function getResource(label, vars = []) {
    const resources = {
        title: 'Adhérez aux alertes par texto de Sephora',
        illustrationAlt: 'Illustration « Adhérez aux alertes par texto de Sephora »',
        description: 'Saisissez votre numéro de téléphone cellulaire ci-dessous pour vous inscrire et toujours profiter des nouveautés, offres et événements exclusifs.',
        phonePlaceholder: 'Saisissez un numéro de téléphone',
        disclaimer1: 'En entrant votre numéro de téléphone, en cliquant sur le bouton « Continuer » et en confirmant votre inscription, vous consentez à recevoir des messages publicitaires automatiques récurrents, y compris des rappels de panier abandonné, et confirmez que vous avez lu et accepté',
        disclaimer2: 'La fréquence des messages varie. Le consentement n’est pas une condition d’achat. Des frais de messagerie texte et de données peuvent s’appliquer. Consultez notre',
        and: 'et',
        privacyPolicy: 'POLITIQUE DE CONFIDENTIALITÉ',
        noticeOfFinancialIncentive: 'AVIS DE PRIME FINANCIÈRE',
        textTerms: 'CONDITIONS D’UTILISATION DE LA MESSAGERIE TEXTE',
        cancelHelp: 'Textez ARRET pour annuler en tout temps. AIDE pour obtenir de l’aide.',
        cancelButton: 'Annuler',
        continueButton: 'Continuer',
        emptyError: 'Veuillez saisir un numéro de téléphone cellulaire.',
        invalidError: 'Veuillez saisir un numéro de téléphone cellulaire valable.',
        confirmationTitle: 'S’abonner aux alertes par texto de Sephora',
        confirmationMessage: 'Vous y êtes presque! Un message texte est en route.',
        confirmationPhonePrefix: 'Nous vous l’avons envoyé au',
        continueShoppingButton: 'Continuer à magasiner',
        errorMsg: 'Veuillez corriger la ou les erreurs dans les champs en surbrillance ci-dessous. ',
        errorSubmitting: 'Désolé, une erreur est survenue lors de la soumission de votre demande. Veuillez réessayer plus tard.'
    };

    return resources[label];
}
